import { render, staticRenderFns } from "./CmgLeaderboardMilestones.vue?vue&type=template&id=5ac85aa2&scoped=true&lang=pug"
import script from "./cmg-leaderboard-milestones.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-milestones.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardMilestones.vue?vue&type=style&index=0&id=5ac85aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac85aa2",
  null
  
)

export default component.exports